import { IContextualMenuItem } from "@fluentui/react";
import InfoOutlineIcon from "@mui/icons-material/InfoOutlined";
import { Tooltip } from "@mui/material";
import { CustomFilterPillProps } from "../../SharedComponents/Interfaces/CustomFilterPill.interfaces";
import { IPartnerReducerType } from "../../interfaces/PartnerView.interfaces";
import { PARTNER_SEARCH_STYLES } from "./PartnerSearch.styles";

/**
 * Custom function named `mapFilterPillMenuItemsPredicate` that
 * converts a string value into an object of type `IContextualMenuItem`.
 */
export const mapPartnerFilterPillMenuItemsPredicate = (value: string): IContextualMenuItem => ({
  key: value,
  text: value
});

export const partnerFilterPillReducer = (
  state: { menuItems: IContextualMenuItem[]; selectedMenuItems: string[] },
  action: { type: IPartnerReducerType; data: IContextualMenuItem[] | string[] }
) => {
  switch (action.type) {
    case IPartnerReducerType.LoadMenuItems:
      return { ...state, menuItems: action.data as IContextualMenuItem[] };
    case IPartnerReducerType.UpdateSelectedMenuItems:
      return { ...state, selectedMenuItems: action.data as string[] };
    default:
      return state;
  }
};

export const createFilterPill = (key: string, name: string): CustomFilterPillProps => {
  return {
    defaultValue: "All",
    isRemovable: true,
    key,
    name,
    styles: PARTNER_SEARCH_STYLES.PARTNER_SEARCH_FILTER_PILL.STYLES
  };
};

export const renderHeaderWithTooltip = (headerName: string | undefined, tooltipText: string) => {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
      {headerName}
      <Tooltip title={tooltipText} style={{ alignItems: "center", marginBottom: 1 }}>
        <InfoOutlineIcon aria-label="Info" sx={{ fontSize: "1.3rem" }} onClick={(e) => e.stopPropagation()} />
      </Tooltip>
    </div>
  );
};
